import _ from 'lodash';
import { CommonModule } from '@angular/common';
import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { UikitFormModule } from 'src/app/shared/modules/uikit-form/uikit-form.module';
import { QUICKSIGNIN_FORM_FIELDS } from './config.const';
import { RouterModule } from '@angular/router';
import { UikitFormComponent } from 'src/app/shared/modules/uikit-form/uikit-form.component';
import { QModalHeaderComponent } from 'src/app/components/modal/q-modal-header.component';
import { QButtonComponent } from 'src/app/components/q-button/q-button.component';
import { SignupQuestionaireComponent } from '../signup-with-questionaire/signup.component';
import { QuickSignInComponent } from '../quick-sign-in/quick-sign-in.component';
import { STORAGE_CONSTANTS } from 'src/app/shared/services/storage.service';

@Component({
    standalone: true,
    selector: 'app-quick-sign-up',
    templateUrl: './quick-sign-up.component.html',
    styleUrls: ['./quick-sign-up.component.scss'],
    imports: [CommonModule, QModalHeaderComponent, UikitFormModule, QButtonComponent, RouterModule]
})
export class QuickSignUpComponent extends SignupQuestionaireComponent implements OnInit, AfterViewInit {
    formFields = _.cloneDeep(QUICKSIGNIN_FORM_FIELDS);
    @ViewChild(UikitFormComponent) uikitFormComponent: UikitFormComponent;

    override ngOnInit() {
        this.convoForm = null;
    }

    override ngAfterViewInit(): void {
        this.convoForm = this.uikitFormComponent.form;
    }

    onClose() {
        this.activeModal.dismiss();
    }

    openSigninPopup() {
        this.onClose();
        this.ngbModal.open(QuickSignInComponent, {
            centered: true, size: 'md', windowClass: 'quick-popup'
        });
    }

    validateEmail() {
        if (this.convoForm?.valid) {
            this.loading = true;
            this.authService.logOut();
            const formData = this.convoForm.getRawValue();
            formData.name = 'Dear';
            this.userService.createUserWithConvo(formData, this.activatedRoute.snapshot.queryParams)
                .subscribe({
                    next: async (resp) => {
                        this.signInWithMagicLink(formData.email);
                    },
                    error: (error) => {
                        this.toastService.error(error);
                        this.handleFailure();
                    }
                });
        }
    }

    handleFailure() {
        this.loading = false;
        this.authService.logOut();
    }

    async signInWithMagicLink(email: string, cb?: Function) {
        const didToken = await this.magicLinkService.login({ email });
        this.authService.createCustomToken({ didToken }).subscribe({
            next: async (resp) => {
                await this.authService.signInWithCustomToken(resp);
                this.storageService.storeInAppCache(STORAGE_CONSTANTS.JUST_LOGGED_IN_EVENT, 'true');
                this.activeModal.dismiss();
                if (cb) cb();
            },
            error: (error) => {
                this.toastService.error(error);
                this.handleFailure();
            }
        });
    }

}
